(() => {
  const qs = (s, c = document) => c.querySelector(s);
  const qsa = (s, c = document) => [...c.querySelectorAll(s)];

  const header = qs('[data-header]');
  const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 24);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  const menuButton = qs('[data-menu-toggle]');
  const menu = qs('[data-mobile-menu]');
  const closeMenu = () => {
    menu?.classList.remove('is-open');
    menuButton?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
  };
  menuButton?.addEventListener('click', () => {
    const open = !menu?.classList.contains('is-open');
    menu?.classList.toggle('is-open', open);
    menuButton.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('menu-open', open);
  });
  qsa('[data-mobile-menu] a').forEach((link) => link.addEventListener('click', closeMenu));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(); });

  const reveal = qsa('[data-reveal]');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    reveal.forEach((el) => observer.observe(el));
  } else {
    reveal.forEach((el) => el.classList.add('is-visible'));
  }

  qsa('[data-hud]').forEach((hud) => {
    const title = qs('[data-hud-title]', hud);
    const copy = qs('[data-hud-copy]', hud);
    const index = qs('[data-hud-index]', hud);
    const modeLabel = qs('[data-hud-mode-label]', hud);
    const hudImage = qs('[data-hud-image]', hud);
    const defaultState = {
      image: hudImage?.getAttribute('src') || '',
      alt: hudImage?.alt || '',
      index: index?.textContent || '',
      label: modeLabel?.textContent || '',
      title: title?.textContent || '',
      copy: copy?.textContent || ''
    };
    const switchHudImage = (source, alt) => {
      if (!hudImage || !source || hudImage.src === source) {
        if (hudImage) hudImage.alt = alt || '';
        return;
      }
      hudImage.classList.add('is-switching');
      const nextImage = new Image();
      nextImage.onload = () => {
        hudImage.src = source;
        hudImage.alt = alt || '';
        hudImage.classList.remove('is-switching');
      };
      nextImage.onerror = () => hudImage.classList.remove('is-switching');
      nextImage.src = source;
    };
    qsa('[data-hud-tab]', hud).forEach((tab) => {
      tab.addEventListener('click', () => {
        const shouldReset = tab.classList.contains('is-active');
        qsa('[data-hud-tab]', hud).forEach((item) => {
          const isActive = !shouldReset && item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', String(isActive));
        });
        if (shouldReset) {
          hud.dataset.mode = 'default';
          index.textContent = defaultState.index;
          title.textContent = defaultState.title;
          copy.textContent = defaultState.copy;
          modeLabel.textContent = defaultState.label;
          switchHudImage(defaultState.image, defaultState.alt);
        } else {
          hud.dataset.mode = tab.dataset.mode;
          index.textContent = tab.dataset.index;
          title.textContent = tab.dataset.title;
          copy.textContent = tab.dataset.copy;
          modeLabel.textContent = tab.dataset.label;
          switchHudImage(tab.dataset.image, tab.dataset.alt);
        }
      });
    });
  });

  qsa('[data-gallery]').forEach((gallery) => {
    const main = qs('[data-gallery-main]', gallery);
    qsa('[data-gallery-thumb]', gallery).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        qsa('[data-gallery-thumb]', gallery).forEach((item) => item.classList.toggle('is-active', item === thumb));
        main.classList.add('is-switching');
        window.setTimeout(() => {
          main.src = thumb.dataset.src;
          main.alt = thumb.dataset.alt;
          main.classList.remove('is-switching');
        }, 120);
      });
    });
  });

  qsa('[data-product-carousel]').forEach((carousel) => {
    const mediaTrack = qs('[data-product-media-track]', carousel);
    const slides = qsa('[data-product-slide]', carousel);
    const thumbs = qsa('[data-product-thumb]', carousel);
    const current = qs('[data-product-current]', carousel);
    if (!mediaTrack || slides.length === 0) return;

    let activeIndex = 0;
    let scrollFrame;
    const setActive = (index, shouldScroll = false) => {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      thumbs.forEach((thumb, thumbIndex) => {
        const isActive = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
      if (current) current.textContent = String(activeIndex + 1);
      if (shouldScroll) {
        mediaTrack.scrollTo({ left: activeIndex * mediaTrack.clientWidth, behavior: 'smooth' });
        thumbs[activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => setActive(index, true)));
    qs('[data-product-prev]', carousel)?.addEventListener('click', () => setActive(activeIndex === 0 ? slides.length - 1 : activeIndex - 1, true));
    qs('[data-product-next]', carousel)?.addEventListener('click', () => setActive(activeIndex === slides.length - 1 ? 0 : activeIndex + 1, true));
    mediaTrack.addEventListener('scroll', () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(() => {
        const index = Math.round(mediaTrack.scrollLeft / Math.max(mediaTrack.clientWidth, 1));
        if (index !== activeIndex) setActive(index);
      });
    }, { passive: true });
    mediaTrack.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); setActive(activeIndex === 0 ? slides.length - 1 : activeIndex - 1, true); }
      if (event.key === 'ArrowRight') { event.preventDefault(); setActive(activeIndex === slides.length - 1 ? 0 : activeIndex + 1, true); }
    });
    setActive(0);
  });

  qsa('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      const target = qs(anchor.getAttribute('href'));
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    });
  });

  const glow = qs('.cursor-glow');
  if (glow && window.matchMedia('(pointer: fine)').matches) {
    window.addEventListener('pointermove', (event) => {
      glow.style.transform = `translate3d(${event.clientX}px, ${event.clientY}px, 0)`;
    }, { passive: true });
  }
})();
